export enum CacheTag {
  cf = 'cf',
  venuesSection = 'venuesSection',
}
